import React from 'react'
import fourm from './fourm.png'
export default function Comp_two() {
  return (
    <div id='Comp_twoy' className='container' >
      <h3 id="disorder_namey">Generalized Anxiety Disorder</h3>
      <hr id='disorder_dividery'></hr>
      <p id='disorder_infoy'>

Generalized anxiety disorder (GAD) usually involves a constant feeling of anxiety or fear.<br/>
More than just worrying about occasional stressful events most of us experience in our lives, <br/>
GAD is an ongoing experience of frequent anxiety that may last for months, or even years.<br/>
What Causes Generalized Anxiety Disorder?<br/>
The symptoms of GAD comes from a complex interaction between biology and environment. Some factors may include genetics, brain function and chemistry, individual personality, development, and one’s perception of threats.

      </p>


      <img src={fourm} id='mone_img'/>
      
    </div>
  )
}
